<template>
  <div class="mainwrap">
    <el-container>
      <i class="switchbar" :class="{ active: !flag }" @click="check"></i>
      <div class="forsidebar" :class="{ active: flag }">
        <div :style="{'top': scrollTop}" ref="aside">
          <Aside v-show="flag"></Aside>
        </div>
      </div>
      <el-container>
        <div class="main" ref="main">
          <Heading></Heading>
          <router-view  :key="$route.fullPath"></router-view>
        </div>
      </el-container>
    </el-container>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'layout',
  data() {
    return {
      flag: true,
      scrollTop: 0,
    }
  },
  watch: {
    '$route'() {
      // 若路由产生变换（退出或提交成功切换回上一页时），将页面数据重置为初始值
      Object.assign(this.$data, this.$options.data())
      // 此处别忘了加上created里需要执行的请求，因为在keep-alive的单页面中切换路由不会执行created钩子
    }
  },
  mounted() {

  },
  methods: {
    check() {
      this.flag = !this.flag
    },
  },
}
</script>
<style lang="scss" scoped>
.forsidebar {
  background: $c;
  &.active {
    width: 258px;
    overflow: inherit;
  }
}
.switchbar {
  width: 0;
  height: 0;
  border-right: 10px solid #fff;
  font-size: 0;
  border-left: 10px solid transparent;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  position: fixed;
  z-index: 9;
  cursor: pointer;
  left: 230px;
  top: 90vh;
  &.active {
    left: 10px;
    border-right: 10px solid $c;
    transform: rotate(180deg);
    &::after {
      background: $c;
    }
  }
  &::after {
    position: absolute;
    width: 4px;
    height: 20px;
    background: var(--card); /* 0819修改 */
    content: '';
    left: 12px;
    top: -10px;
  }
}
.main {
  
}
</style>
